import type { BrandItem } from '../types';

/**
 * Brand logos from Assets/svg — files live in public/images/brands/.
 * Black artwork; inverted to white in BrandShowcase CSS.
 */
export const brands: BrandItem[] = [
  { id: 'audi', name: 'Audi', logoSrc: '/images/brands/audi.svg' },
  { id: 'bmw', name: 'BMW', logoSrc: '/images/brands/bmw.svg' },
  { id: 'citroen', name: 'Citroën', logoSrc: '/images/brands/citroen.svg' },
  { id: 'honda', name: 'Honda', logoSrc: '/images/brands/honda.svg' },
  { id: 'kia', name: 'KIA', logoSrc: '/images/brands/kia.svg' },
  { id: 'mercedes', name: 'Mercedes-Benz', logoSrc: '/images/brands/mercedes.svg' },
  { id: 'nissan', name: 'Nissan', logoSrc: '/images/brands/nissan.svg' },
  { id: 'skoda', name: 'Škoda', logoSrc: '/images/brands/skoda.svg' },
  { id: 'toyota', name: 'Toyota', logoSrc: '/images/brands/toyota.svg' },
  { id: 'vw', name: 'Volkswagen', logoSrc: '/images/brands/vw.svg' },
];
